import classNames from 'classnames';
import { SortDirection } from '@tanstack/react-table';
import SortUpIcon from '@enerex/unified-ui-react/icons/SortUpIcon';
import SortDownIcon from '@enerex/unified-ui-react/icons/SortDownIcon';

import Div from 'components/Div';

type SortingIconProps = {
    isSorted?: SortDirection | false;
};

const SortingIcon = ({ isSorted = false }: SortingIconProps) => {
    return (
        <Div
            className="d-flex flex-column"
            style={{ width: 'fit-content' }}
            role="button"
        >
            <SortUpIcon
                size="sm"
                className={classNames(
                    isSorted === 'asc' ? 'text-primary' : 'text-secondary'
                )}
            />
            <SortDownIcon
                size="sm"
                className={classNames(
                    isSorted === 'desc' ? 'text-primary' : 'text-secondary'
                )}
                style={{ marginTop: '-10px' }}
            />
        </Div>
    );
};

export default SortingIcon;
